import React from 'react'
import PropTypes from 'prop-types'

import FOBrokerage from './shared/FOBrokerage'

export default function CommodityBrokerage({ broker }) {
  const { commodity_futures_brokerage, commodity_options_brokerage } = broker

  if (!commodity_futures_brokerage) return null

  return (
    <FOBrokerage
      broker={broker}
      foType="Commodity"
      futures_brokerage={commodity_futures_brokerage}
      options_brokerage={commodity_options_brokerage}
    />
  )
}

CommodityBrokerage.propTypes = {
  broker: PropTypes.object.isRequired,
}
